<template>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 p-md-6">
      <Checkbox 
        inputId="irdActive" 
        v-model="irdActive" 
        :binary="true" 
        :trueValue="true" 
        :falseValue="false"
      />
      <label for="irdActive" class="p-ml-2">IRD Active</label>
    </div>
    
    <div v-if="irdActive" class="p-col-12">
      <div class="p-field p-col-12 p-md-6">
        <label for="irdUsername">IRD Username</label>
        <InputText 
          id="irdUsername" 
          v-model="irdUsername" 
          placeholder="Enter IRD username" 
          required
        />
      </div>
      
      <div class="p-field p-col-12 p-md-6">
        <label for="irdPassword">IRD Password</label>
        <InputText 
          id="irdPassword" 
          v-model="irdPassword" 
          placeholder="Enter IRD password" 
          required
        />
      </div>
    </div>
    <div class="p-field p-col-12 p-md-6">
      <Button 
        label="Save" 
        icon="pi pi-save" 
        @click="updateOrganisationIRD" 
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'IRDForm',
  data() {
    return {
      irdActive: this.$store.getters.organisationIRDActive || false,
      irdUsername: this.$store.getters.irdUsername || '',
      irdPassword: this.$store.getters.irdPassword || '',
      loading: false
    }
  },
  methods: {
    async updateOrganisationIRD() {
      // if (!this.irdActive) {
      //   this.$toast.add({
      //     severity: 'warn',
      //     summary: 'Warning',
      //     detail: 'Please activate IRD'
      //   })
      //   return
      // }
      if (this.irdActive && (!this.irdUsername || !this.irdPassword)) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please fill in both username and password when IRD is active'
        })
        return
      }
      this.loading = true
      try {
        const formData = new FormData()
        const organisationData = {
          id: this.$store.getters.organisationId,
          irdActive: this.irdActive,
          irdUsername: this.irdActive ? this.irdUsername : null,
          irdPassword: this.irdActive ? this.irdPassword : null
        }
        formData.append('organisation', JSON.stringify(organisationData))
        const emptyFile = new File([], '', { type: 'application/octet-stream' })
        formData.append('files', emptyFile)
        const response = await this.$store.dispatch('updateIRDOrganization', formData)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'IRD details updated!'
          })
          this.$store.commit('updateIRDSettings', {
            irdActive: this.irdActive,
            irdUsername: this.irdUsername,
            irdPassword: this.irdPassword
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data.message || 'Failed to update IRD details'
          })
        }
      } catch (err) {
        console.error('IRD Update Error:', err)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: err.response.data.message || 'Something went wrong.'
        })
      } finally {
        this.loading = false
      }
    },
    async loadOrganisationData() {
      try {
        const response = await this.$store.dispatch('loadOrganisation')
        const org = response.data.data
        this.irdActive = org.irdActive || false
        this.irdUsername = org.irdUsername || ''
        this.irdPassword = org.irdPassword || ''
      } catch (err) {
        console.error('Failed to load organisation:', err)
      }
    }
  },
//   watch: {
//     irdActive(newVal) {
//       if (!newVal) {
//         this.irdUsername = ''
//         this.irdPassword = ''
//       }
//     }
//   },
  mounted() {
    this.loadOrganisationData()
  },
  components: {
    Checkbox,
    Button,
    InputText
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// IRDSetup.vue?77cca2a6